import React from "react";
import {
  BarChart,
  Bar,
  Tooltip,
  XAxis,
  YAxis,
  ResponsiveContainer
} from "recharts";
import _ from "lodash";
import Teams from "api/Teams";
import Styled from "components/finance/style";
import { view } from "@risingstack/react-easy-state";

const numberWithCommas = val => {
  val = val.toFixed(0);
  return "$" + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

function Chart({ loans = [], equity = 0 }) {
  let bar = {};

  loans.forEach(loan => {
    bar[loan.client_name] = loan.amount;
  });

  bar["Equity"] = equity;

  const bars = [bar];
  const colors = _.zipObject(
    loans.map(i => i.client_name),
    Teams.debtsColors()
  );
  const equity_color = Teams.equityColor();
  let legendItems = loans.filter(i => i.amount > 0).map(i => i.client_name);
  legendItems.reverse();

  return (
    <Styled.Chart.Wrapper>
      <Styled.Chart.Chart>
        <ResponsiveContainer width="100%" height={108}>
          <BarChart
            data={bars}
            reverseStackOrder={true}
            layout="vertical"
            margin={{ top: 0, left: 0, right: 0, bottom: 0 }}
          >
            <Tooltip formatter={numberWithCommas} />
            <XAxis type="number" hide={true} />
            <YAxis type="category" hide={true} />
            {loans.map((loan, i) => (
              <Bar
                key={i}
                barSize={200}
                dataKey={loan.client_name}
                stackId="a"
                fill={colors[loan.client_name]}
              />
            ))}
            <Bar
              barSize={200}
              dataKey="Equity"
              stackId="a"
              fill={equity_color}
            />
          </BarChart>
        </ResponsiveContainer>
      </Styled.Chart.Chart>
      <Styled.Chart.Legend>
        {["Equity", ...legendItems].map(key => (
          <Styled.Chart.LegendItem key={key} bold={key !== "Equity"}>
            <Styled.Chart.LegendItemCircle
              color={key !== "Equity" ? colors[key] : equity_color}
            />
            <div>{key}</div>
          </Styled.Chart.LegendItem>
        ))}
      </Styled.Chart.Legend>
    </Styled.Chart.Wrapper>
  );
}

export default view(Chart);



// WEBPACK FOOTER //
// ./src/components/finance/decisions/chart.js